<div class="notification-list">
    <div class="notification-header">
        <h3>Notifications
            <span class="notification-count">({{ (notifications$ | async)?.length || 0 }})</span>
        </h3>
        <div class="header-actions">
            <button class="btn-icon" (click)="markAllAsRead()" title="Tout marquer comme lu">✓</button>
            <button class="btn-icon" (click)="clearAll()" title="Tout effacer">🗑️</button>
        </div>
    </div>

    <div class="notifications-container">
        <div
            *ngFor="let notification of notifications$ | async; trackBy: trackByAlertId"
            class="notification-item"
            [class.unread]="!notification.read"
            [class.clickable]="isNavigationEnabled()"
            [class]="'notification-' + notification.level.toLowerCase()"
            (click)="onNotificationClick(notification)"
            [attr.role]="isNavigationEnabled() ? 'button' : null"
            [attr.tabindex]="isNavigationEnabled() ? 0 : null"
            (keypress)="isNavigationEnabled() && $event.key === 'Enter' && onNotificationClick(notification)"
        >
                <div class="notification-icon">
                    {{ getIcon(notification.type) }}
                </div>

                <div class="notification-content">
                    <div class="notification-header-row">
                        <div class="notification-title-group">
                            <h4 class="notification-title">{{ notification.title }}</h4>
                            <span class="notification-level-badge" [class]="'badge-' + notification.level.toLowerCase()">
                                {{ notification.level }}
                            </span>
                        </div>
                        <span class="notification-time">{{
                                formatTimeAgo(notification.timestamp)
                            }}</span>
                    </div>

                    <p class="notification-message">{{ notification.message }}</p>

                    <div *ngIf="notification.missionInfo" class="mission-info">
                        <div class="mission-details">
                            <span *ngIf="notification.missionInfo.reference" class="mission-ref">
                                <i class="pi pi-briefcase"></i>
                                {{ notification.missionInfo.reference }}
                            </span>
                            <span *ngIf="notification.missionInfo.status" class="mission-status" [class]="'status-' + notification.missionInfo.status.toLowerCase()">
                                {{ notification.missionInfo.status }}
                            </span>
                        </div>
                        <div class="mission-participants" *ngIf="notification.missionInfo.clientName || notification.missionInfo.driverName">
                            <span *ngIf="notification.missionInfo.clientName" class="participant">
                                <i class="pi pi-user"></i>
                                {{ notification.missionInfo.clientName }}
                            </span>
                            <span *ngIf="notification.missionInfo.driverName" class="participant">
                                <i class="pi pi-car"></i>
                                {{ notification.missionInfo.driverName }}
                            </span>
                        </div>
                        <div *ngIf="notification.missionInfo.location" class="mission-location">
                            <i class="pi pi-map-marker"></i>
                            <span>{{ notification.missionInfo.location }}</span>
                        </div>
                    </div>

                    <a
                        *ngIf="notification.actionUrl && isNavigationEnabled()"
                        class="notification-action"
                        (click)="$event.stopPropagation()"
                    >
                        <i class="pi pi-arrow-right"></i>
                        Voir détails
                    </a>
                </div>

                <div class="notification-actions">
                    <button
                        *ngIf="!notification.read && notification.alertId"
                        class="btn-action"
                        (click)="markAsRead($event, notification.alertId!)"
                        title="Marquer comme lu"
                    >
                        ✓
                    </button>
                    <button
                        *ngIf="notification.alertId"
                        class="btn-action"
                        (click)="removeNotification($event, notification.alertId!)"
                        title="Supprimer"
                    >
                    </button>
                </div>
        </div>

        <div *ngIf="(notifications$ | async)?.length === 0" class="empty-state">
            <p>Aucune notification</p>
        </div>
    </div>
</div>
